import { render, staticRenderFns } from "./FlashCardToggleRevise.vue?vue&type=template&id=b481b29a&"
import script from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardHeader/FlashCardToggleRevise?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardHeader/FlashCardToggleRevise?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports